import { useEffect } from 'react'

import { BootCampItemGroq, BootcampOverviewUserData } from '~/types/bootcamp'
import { useGetUserVideoCoursesDataListQuery } from '~/bootcamp/apis/get-overview.api'

const useProcessVideoCourseListData = (
  gymType: string,
  userId: number | null,
  subjectList: BootCampItemGroq[],
): BootcampOverviewUserData[][] => {
  const courseList: BootcampOverviewUserData[][] = []

  const { data, refetch } = useGetUserVideoCoursesDataListQuery(
    {
      gymType,
      userId: userId ?? -1,
    },
    { skip: !userId },
  )

  useEffect(() => {
    if (userId) {
      refetch()
    }
  }, [userId, refetch])

  subjectList.forEach((subject, index) => {
    const subjects = data?.filter((userSubject) => userSubject.bootcampId === subject.key)
    courseList[index] = subjects || []
  })

  return courseList
}

export default useProcessVideoCourseListData
